/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */

/**
 * Defines the default path for resolving an external theme.json document.
 *
 * ```typescript
 *   import {CUSTOM_THEME_PATH} from '@ion/dls/src/theme/theme.config';
 * ```
 */
export const CUSTOM_THEME_PATH = 'theme.json';

/**
 * Defines the default path for resolving an external theme logo image.
 *
 * ```typescript
 *   import {CUSTOM_LOGO_PATH} from '@ion/dls/src/theme/theme.config';
 * ```
 */
export const CUSTOM_LOGO_PATH = 'assets/img/logo.png';

/**
 * Defines the default path for resolving an external theme background
 * image.
 *
 * ```typescript
 *   import {BACKGROUND_IMG_PATH} from '@ion/dls/src/theme/theme.config';
 * ```
 */
export const BACKGROUND_IMG_PATH = 'assets/img/bg.jpg';
